import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ObtenerNumeroGruposService {
  private readonly gruposUrl: string;

  constructor(private httpClient: HttpClient) {
    this.gruposUrl = environment.apiUrl + '/administrador/grupos/total';
  }

  public __invoke(): Observable<number> {
    return this.httpClient.get<number>(this.gruposUrl);
  }
}
